<template>
  <div class = "all-box" >
    <div ref = 'pronbit'>
      <heads :class = " isFixed ? 'headswhite':'heads' "></heads>
    </div>
    <div class = "content-box">
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive> -->
          <router-view ></router-view>
          <!-- <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view> -->
         <div class = 'posiBox1' v-if = 'fankui && homefankui' @click = 'handleclickfankui'>
            <a class = 'itembox'>
              <img class = 'itemImg' src="../../../static/images/yjfk.svg" alt="">
              <a  class="louti">意见反馈</a>
            </a>
          </div> 
    </div> 
    <backtop v-if = 'fankui && homefankui' :showIdea = 'showIdea' @closefankui = 'closefankui'></backtop>
    <footers v-if = 'seachflag' class = 'footer'></footers>

  </div>
</template>

<script>

import heads from '../head/head';
import footers from '../footers/footers';
import backtop from "../backtop/index.vue";

export default {
  data () {
    return {
      isFixed:false,
      showIdea:false
    }
  },
  mounted () {
      window.addEventListener('scroll',this.handleScroll,true)
      this.initcocation()

  },
  computed: {
    locationFlag(){
      return this.$store.state.locationFlag
    },
    seachflag(){
      return this.$store.state.seachflag
    },
    fankui(){
      return this.$store.state.fankuiflag
    },
    homefankui(){
      return this.$store.state.homefankuiflag
    }
    
    
  },
  components:{
    heads,footers,backtop
  },
  methods: {
    closefankui(){
      this.showIdea = false
    },
    handleclickfankui(){
      this.showIdea = true
    },
      initcocation(){
      
      },
      handleScroll(){
        if(this.locationFlag){
          let top = this.$refs.pronbit.getBoundingClientRect().top;
          if(top <= '-64'){
            this.isFixed = true
          }else{
            this.isFixed = false
          }
        }else{
          this.isFixed = true
        }
        
    },
    
  }
}
</script>


<style lang="less" scoped>
  .all-box{
    width:100%;
    height:100%;
    background:#fff;
    min-width:1350px;
    overflow: auto;
    .heads{
      height:64px;
      position:fixed;
      top:0;
      left:0;
      right:0;
      z-index:1000;
      height: 64px;
      background-color: rgba(255, 255, 255, 0.5);
    }
    .headswhite{
      height:64px;
      position:fixed;
      top:0;
      left:0;
      right:0;
      z-index:1000;
      height: 64px;
      background-color: #fff;
    }
    .content-box{
      background:#fff;
      .posiBox1{
    width: 76px;
	  background-color: #f2f5fa;
    box-shadow: 0px 2px 8px 0px 
      #efefef;
    border-radius: 5px;
    position:fixed;
    right:10px;
    top:650px;
    z-index:600;
    box-sizing: border-box;
    box-sizing: border-box;
    .itembox{
      width:76px;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      cursor: pointer;
      .itemImg{
        width: 44px;
	      height: 44px;
        margin:10px 0;
      }
      .louti{
        width: 56px;
        line-height: 20px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #222222;
        text-align: center;
        // margin-top:5px;
      }
    }
    .itembox:hover .louti{
      color: #2c6eff;
    }
    
    .louti:hover{
      color: #2c6eff;
    }
  }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue